import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as cls from "./references.module.scss";
import { Button, ErrataView, ErrataWidget, WidgetFrame } from "../../../personal-studio-components/studio";
import { useSelector } from "react-redux";
import CertificatesList from "../../components/certificatesList/CertificatesList";
import Loader from "../../components/loader/Loader";
import { Snackbar } from "@mui/material";
import { StudentService } from "../../components/studentService";
import { Config } from "../../../personal-studio-components/service/Config.js";
import { ErrataViewInfo } from "../../../personal-studio-components/service/ErrataViewInfo";

const MorphoService = Config.createService("morpho_api");

function References() {
  const { access_token } = useSelector((state) => state.token);
  const { contractId } = useSelector((state) => state.contract);
  const [menu, setMenu] = useState(null);
  const [deliveryPlaceId, setDeliveryPlaceId] = useState(1);
  const [certificateTypeId, setCertificateTypeId] = useState(null);
  const [referenceName, setReferenceName] = useState("");
  const [currentCourseIdx, setCurrentCourseIdx] = useState(0);
  const [menuItemData, setMenuItemData] = useState({});
  const [counter, setCounter] = useState(1);
  const [createCertProcess, setCreateCertProcess] = useState(null);
  const [response, setResponse] = useState(null);
  const [data, setData] = useState(null);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isEdited, setIsEdited] = useState(false);
  const {
    handleSubmit,
    register,
    getValues,
    watch,
    formState: { isValid, errors },
    setValue,
  } = useForm();

  // 2. Отслеживаем обязательные поля для проверки склонения
  const surnameDatel = watch("surname_datel");
  const nameDatel = watch("name_datel");

  // Флаг: заполнены ли оба обязательных поля (с учетом удаления пробелов)
  const isDeclensionReady = Boolean(surnameDatel?.trim() && nameDatel?.trim());

  async function getList() {
    if (access_token) {
      const request = {
        method: "post",
        path: "/student/applications/certificates/list",
        data: {
          access_token,
          study_contract_id: contractId,
        },
      };
      await StudentService.send(request, (response) => {
        if (response) {
          setData(response);

          if (response.errors) {
            const errorEvent = new ErrorEvent("error", {
              error: response,
            });
            window.dispatchEvent(errorEvent);
            return;
          }
        }
      });
    }
  }

  async function getCertificatesMenu() {
    if (access_token) {
      const request = {
        method: "post",
        path: "/student/applications/certificates/menu",
        data: {
          access_token,
          study_contract_id: contractId,
        },
      };
      await StudentService.send(request, (response) => {
        if (response && !response.errors) {
          setMenu(response);
          const firstItem = response[0];
          setMenuItemData(firstItem);
          setReferenceName(firstItem.certificate_type_full_name);
          setCertificateTypeId(firstItem.certificate_type_id);

          const targetItem = response.find((item) => item.certificate_type_id === 1);

          setSubmitBtnDisabled(false);

          if (targetItem) {
            if (targetItem.surname) setValue("surname_datel", targetItem.surname);
            if (targetItem.name) setValue("name_datel", targetItem.name);
            if (targetItem.secname) setValue("secname_datel", targetItem.secname);
          }
        } else if (response) {
          setMenu(response);
          const errorEvent = new ErrorEvent("error", {
            error: response,
          });
          window.dispatchEvent(errorEvent);
        }
      });
    }
  }

  async function createCertificate(formData) {
    formData.reason_invitation_id = Number(formData.reason_invitation_id);
    for (const key in formData) {
      if (!formData[key] || formData[key] === "Не выбрано") delete formData[key];
    }
    if (access_token) {
      const request = {
        method: "post",
        path: "/student/applications/certificates/create",
        data: {
          ...formData,
          access_token,
          study_contract_id: contractId,
          count_copies: counter,
          delivery_place_id: deliveryPlaceId,
          check: true,
        },
      };
      setCreateCertProcess("process");

      const data = await StudentService.send(request, setResponse);
      if (!data.errors) {
        const request = {
          method: "post",
          path: "/student/applications/certificates/create",
          data: {
            ...formData,
            access_token,
            study_contract_id: contractId,
            count_copies: counter,
            delivery_place_id: deliveryPlaceId,
            check: false,
          },
        };
        setTimeout(() => {
          getList();
        }, 2000);
        const data = await StudentService.send(request, setResponse);
        if (!data.errors) {
          setCreateCertProcess("success");
          window.open(data.url);
          setTimeout(() => {
            setCreateCertProcess(null);
          }, 5000);
        } else {
          const errorEvent = new ErrorEvent("error", {
            error: data,
          });
          window.dispatchEvent(errorEvent);
          setCreateCertProcess(null);
        }
      } else {
        const errorEvent = new ErrorEvent("error", {
          error: data,
        });
        window.dispatchEvent(errorEvent);
        setCreateCertProcess(null);
      }
    }
  }

  // async function getDeclension(e) {
  //   if (e) e.preventDefault();

  //   const fields = [
  //     { name: "surname_datel", text: getValues("surname_datel") },
  //     { name: "name_datel", text: getValues("name_datel") },
  //     { name: "secname_datel", text: getValues("secname_datel") },
  //   ].filter((field) => field.text && field.text.trim() !== "");

  //   if (fields.length === 0) return;

  //   setLoading(true);

  //   try {
  //     const requests = fields.map(async ({ name, text }) => {
  //       const request = {
  //         method: "post",
  //         path: "/declension",
  //         data: {
  //           text,
  //           is_surname: name == "surname_datel" || name === "secname_datel",
  //           cases: ["dative"],
  //         },
  //       };
  //       const response = await MorphoService.send(request);
  //       if (!response || response.errors) {
  //         const errorEvent = new ErrorEvent("error", {
  //           error: response || { message: "Ошибка выполнения запроса" },
  //         });
  //         window.dispatchEvent(errorEvent);
  //         return null;
  //       }

  //       if (response.dative) {
  //         setValue(name, response.dative, {
  //           shouldValidate: true,
  //           shouldDirty: true,
  //         });
  //       }

  //       return response;
  //     });

  //     const responses = await Promise.all(requests);

  //     const allSuccessful = responses.every((res) => Boolean(res && res.dative && !res.errors));
  //     if (allSuccessful) {
  //       setSubmitBtnDisabled(false);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   } finally {
  //     setLoading(false);
  //   }
  // }
  async function getDeclension(e) {
    if (e) e.preventDefault();
    const text = `${getValues("surname_datel") || ""} ${getValues("name_datel") || ""} ${getValues("secname_datel") || ""}`.trim();
    if (text.length === 0) return;

    setLoading(true);

    try {
      const request = {
        method: "post",
        path: "/declension",
        data: {
          is_fio: true,
          text,
          cases: ["dative"],
        },
      };
      const response = await MorphoService.send(request);
      if (!response || response.errors) {
        const errorEvent = new ErrorEvent("error", {
          error: response || { message: "Ошибка выполнения запроса" },
        });
        window.dispatchEvent(errorEvent);
        return null;
      }
      if (response.dative) {
        if (response.dative.surname) setValue("surname_datel", response.dative.surname, { shouldValidate: true, shouldDirty: true });
        if (response.dative.name) setValue("name_datel", response.dative.name, { shouldValidate: true, shouldDirty: true });
        if (response.dative.secname) setValue("secname_datel", response.dative.secname, { shouldValidate: true, shouldDirty: true });
      }
      setSubmitBtnDisabled(false);
      setIsEdited(false);
      return response;
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }
  const handleChangeMenuElement = (idx, certificate_type_id) => {
    setCurrentCourseIdx(idx);
    setCertificateTypeId(certificate_type_id);
    setSubmitBtnDisabled(false);
    setIsEdited(false);
    const selectedMenu = menu[idx];
    setMenuItemData(selectedMenu);
    setReferenceName(selectedMenu.certificate_type_full_name);

    if (certificate_type_id === 1) {
      const targetItem = menu.find((item) => item.certificate_type_id === 1);
      if (targetItem) {
        if (targetItem.surname) setValue("surname_datel", targetItem.surname);
        if (targetItem.name) setValue("name_datel", targetItem.name);
        if (targetItem.secname) setValue("secname_datel", targetItem.secname);
      }
    }
  };

  const handleOptionChange = (option) => {
    setDeliveryPlaceId(option);
  };

  const handleFieldChange = () => {
    if (!isEdited) {
      setIsEdited(true);
      setSubmitBtnDisabled(true);
    }
  };

  useEffect(() => {
    getCertificatesMenu();
  }, []);

  if (menu)
    return (
      <>
        <WidgetFrame type="blue" icon="survey" title="Подать заявку">
          {menu.errors ? (
            <>{menu.error_type === "info" ? <ErrataViewInfo errata={menu} /> : <ErrataView errata={menu} />}</>
          ) : (
            <>
              <div>
                {menu.map(({ certificate_type_short_name, certificate_type_id }, idx) => (
                  <span
                    key={idx}
                    className={`${cls.menuItem} ${currentCourseIdx === idx ? cls.active : ""}`}
                    onClick={() => handleChangeMenuElement(idx, certificate_type_id)}
                  >
                    {certificate_type_short_name}
                  </span>
                ))}
              </div>
              <div>
                <div className={cls.title}>{referenceName} </div>
                <span>
                  {certificateTypeId === 1 &&
                    "В полях с красной рамкой указаны Ваши ФИО в именительном падеже. Нажмите на кнопку «Получить склонение» и проверьте правильность указания Ваших ФИО в дательном падеже. Если Ваши ФИО склоняются иначе, то внесите вручную корректировки. Убедитесь, что всё указано верно, после чего подайте заявку."}
                </span>
              </div>

              <form
                onSubmit={handleSubmit((formData) =>
                  createCertificate({
                    ...formData,
                    certificate_type_id: certificateTypeId,
                  }),
                )}
              >
                {certificateTypeId === 1 && (
                  <div>
                    <div>
                      <div>Наименование работодателя *</div>
                      <input
                        className={`${cls.input} ${errors.organization_name ? cls.errorInput : ""}`}
                        {...register("organization_name", { required: "Введите наименование работодателя " })}
                      />
                      {errors.organization_name && <span className={cls.errorText}>{errors.organization_name.message}</span>}
                    </div>
                    <div>
                      <div>Вид аттестационных мероприятий *</div>
                      <select
                        className={`${cls.select} ${errors.reason_invitation_id ? cls.errorSelect : ""}`}
                        defaultValue=""
                        {...register("reason_invitation_id", { required: "Выберите вид аттестации" })}
                      >
                        <option disabled value="">
                          Не выбрано
                        </option>
                        {menuItemData?.reason_invitations?.map(({ reason_invitation_id, reason_invitation_name }) => (
                          <option key={reason_invitation_id} value={reason_invitation_id}>
                            {reason_invitation_name}
                          </option>
                        ))}
                      </select>
                      {errors.reason_invitation_id && <span className={cls.errorText}>{errors.reason_invitation_id.message}</span>}
                    </div>
                    <div className={cls.inputDatelRoot}>
                      <div>
                        <div>Фамилия в дательном падеже *</div>
                        <div className={cls.inputDatelMessage}>
                          Перед сохранением заявки проверьте правильность указания Вашей фамилии в дательном падеже (кому?) и, по
                          необходимости, откорректируйте
                        </div>
                      </div>
                      <input
                        className={`${cls.input} ${cls.inputDatel}`}
                        {...register("surname_datel", {
                          required: true,
                          onChange: handleFieldChange,
                        })}
                      />
                    </div>
                    <div className={cls.inputDatelRoot}>
                      <div>
                        <div>Имя в дательном падеже *</div>
                        <div className={cls.inputDatelMessage}>
                          Перед сохранением заявки проверьте правильность указания Вашего имени в дательном падеже (кому?) и, по
                          необходимости, откорректируйте
                        </div>
                      </div>
                      <input
                        className={`${cls.input} ${cls.inputDatel}`}
                        {...register("name_datel", {
                          required: true,
                          onChange: handleFieldChange,
                        })}
                      />
                    </div>
                    <div className={cls.inputDatelRoot}>
                      <div>
                        <div>Отчество в дательном падеже</div>

                        <div className={cls.inputDatelMessage}>
                          Перед сохранением заявки проверьте правильность указания Вашего отчества в дательном падеже (кому?) и, по
                          необходимости, откорректируйте
                        </div>
                      </div>
                      <input
                        className={`${cls.input} ${cls.inputDatel}`}
                        {...register("secname_datel", {
                          onChange: handleFieldChange,
                        })}
                      />
                    </div>

                    {isDeclensionReady && isEdited && (
                      <div style={{ margin: "10px 0" }}>
                        {loading ? (
                          <Loader />
                        ) : (
                          <Button onClick={getDeclension} type="primary">
                            Проверить склонение
                          </Button>
                        )}
                      </div>
                    )}
                  </div>
                )}
                {certificateTypeId === 2 && (
                  <div className={cls.copyCountContainer}>
                    <div>Количество копий</div>
                    <div className={cls.btnContainer}>
                      <button type="button" onClick={() => setCounter((prev) => Math.max(1, prev - 1))} className={cls.btn}>
                        -
                      </button>
                      <div className={cls.counter}>{counter}</div>

                      <button type="button" onClick={() => setCounter((prev) => prev + 1)} className={cls.btn}>
                        +
                      </button>
                    </div>
                  </div>
                )}
                <div className={cls.deliveryPlace}>
                  <label className={cls.note}>Место получения справки</label>
                  <label className={cls.address}>
                    <input type="radio" name="paymentOption" checked={deliveryPlaceId === 1} onChange={() => handleOptionChange(1)} />
                    Айдинг-центр
                  </label>
                  <label className={cls.address}>
                    <input type="radio" name="paymentOption" checked={deliveryPlaceId === 2} onChange={() => handleOptionChange(2)} />
                    Офис-центр УМНЕЙ (109029, г. Москва, вн.тер.г. муниципальный округ Таганский, ул. Нижегородская, д. 32, стр. 4)
                  </label>
                </div>
                {createCertProcess === "process" ? (
                  <Loader />
                ) : (
                  <Button disabled={submitBtnDisabled} type="primary">
                    Подать заявку
                  </Button>
                )}
              </form>
            </>
          )}
        </WidgetFrame>
        <WidgetFrame type="blue" icon="survey" title="История обращений">
          <CertificatesList getList={getList} data={data} setData={setData} />
          <Snackbar message="Заявка успешно подана. Пожалуйста, дождидесь загрузки документа" open={createCertProcess === "success"} />
        </WidgetFrame>
      </>
    );
}

export default References;
